import { NewOrderModal } from "./NewOrderModal";

export default NewOrderModal;
